/**
 * Vue query button types
 * @readonly
 * @enum {string}
 */
export const ButtonNames = {
  Close: "close",
  Confirm: "confirm",
  Today: "today",
  Now: "now",
  Export: "export",
};

/**
 * Field type from BE
 * @readonly
 * @enum {string}
 */
export const FieldTypes = {
  String: "string",
  Boolean: "boolean",
  Bool: "bool",
  Date: "date",
  Autocomplete: "autocomplete",
  Records: "records",
  Percentage: "percentage",
  Link: "link",
  Attachment: "attachments",
  Email: "email",
  Select: "select",
  DateTime: "datetime",
  EasyGoogleMapAddress: "easy_google_map_address",
  Text: "text",
  DateRange: "dateRange",
  RadioGroup: "radioGroup",
  Number: "number",
  Tags: "tags",
  EasyPercent: "easy_percent",
  CountrySelect: "country_select",
  List: "list",
  Flag: "flag",
  Autoincrement: "autoincrement",
  ValueTree: "value_tree",
  User: "user",
  Version: "version",
  Numeric: "numeric",
  Enumeration: "enumeration",
  EasyLookup: "easy_lookup",
  DependentList: "dependent_list",
  Record: "record",
  Image: "image",
  Phone: "phone",
  Roles: "roles",
  Amount: "amount",
  Address: "",
  Int: "int",
  Integer: "integer",
  Float: "float",
  Duration: "duration",
  Time: "time",
  CustomTable: "custom_table",
  EasyComputedToken: "easy_computed_token",
};

export const ColumnsIdentifiers = {
  Indicator: "easy_indicator",
  Attachments: "attachments",
  Flag: "flag",
  Relation: "relations",
  Issues: "issues",
  Subject: "subject",
  Pbi: "easy_product_backlog_items",
  PersonalContacts: "easy_personal_contacts",
};

/**
 * AntInline input component names
 * @readonly
 * @enum {string}
 */
export const InputTypes = {
  Autocomplete: "autocomplete",
  Checkbox: "checkbox",
  Date: "date",
  Number: "number",
  Select: "select",
  Percentage: "percentage",
  Boolean: "boolean",
  RadioGroup: "radioGroup",
  DateRange: "dateRange",
  Flag: "flag",
  Cascader: "cascader",
  String: "string",
  TimePicker: "time",
};

/**
 * Component names of editors
 * @readonly
 * @enum {string}
 */
export const EditorTypes = {
  LongTextEditor: "LongTextEditor",
  TagsEditor: "TagsEditor",
  AntInline: "AntInline",
};

/**
 * Loading status
 * @readonly
 * @enum
 */
export enum LoadingStatus {
  Init,
  Loading,
  Loaded,
  Submitting,
  Submitted,
}

export enum AntSelectModes {
  Multiple = "multiple",
  Tags = "tags",
}
